import { render, staticRenderFns } from "./MergeHeader.vue?vue&type=template&id=284c4304"
import script from "./MergeHeader.vue?vue&type=script&lang=js"
export * from "./MergeHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports